/* Snugday product page: ported from trgovina/prototip/index.html, with the real Shopify AJAX cart. */
(() => {
  const dataEl = document.getElementById("sd-data");
  const DATA = dataEl ? JSON.parse(dataEl.textContent) : { tiers: [], guideImages: {}, currency: "USD", selected: "3" };
  const TIERS = DATA.tiers;
  const ALL_GUIDES = [...new Set(TIERS.flatMap(t => t.guides))];
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  const fmt = new Intl.NumberFormat("en-US", { style: "currency", currency: DATA.currency || "USD" });
  const money = cents => fmt.format(cents / 100);
  const tierById = id => TIERS.find(t => t.id === String(id));
  const tierByVariant = vid => TIERS.find(t => t.variantId === vid);
  const plural = n => `${n} belt${n > 1 ? "s" : ""}`;
  let selected = (tierById(DATA.selected) || TIERS[TIERS.length - 1] || {}).id;

  /* ---- bundle selection ---- */
  function selectTier(id) {
    const t = tierById(id);
    if (!t) return;
    selected = t.id;
    document.querySelectorAll(".tier").forEach(el => {
      const input = el.querySelector("input");
      const on = input.dataset.tier === t.id;
      el.classList.toggle("on", on);
      input.checked = on;
    });
    document.querySelectorAll("[data-price]").forEach(el => (el.textContent = money(t.price)));
    document.querySelectorAll("[data-compare]").forEach(el => (el.textContent = t.compare ? money(t.compare) : ""));
    const badge = document.querySelector("[data-save-badge]");
    if (badge) {
      badge.hidden = !t.compare;
      if (t.compare) badge.textContent = `SAVE ${Math.round((1 - t.price / t.compare) * 100)}%`;
    }
    const bonus = document.querySelector("[data-bonus]");
    if (bonus) bonus.textContent = "Free guides (PDF): " + t.guides.join(" + ");
    const inc = document.querySelector("[data-included]");
    if (inc) inc.textContent = `Your selected bundle: ${t.units} heat belt${t.units > 1 ? "s" : ""}, each in its own gift box with a USB-C charging cable and a thank-you card. By email: ${t.guides.join(", ")} (PDF).`;
    document.querySelectorAll("[data-tier-name]").forEach(el => (el.textContent = `${t.name} · ${plural(t.units)} `));
    document.querySelectorAll("[data-units]").forEach(el => (el.textContent = `${plural(t.units)} · `));
  }
  document.querySelectorAll(".tier input").forEach(input => input.addEventListener("change", () => selectTier(input.dataset.tier)));

  /* ---- gallery ---- */
  function renderGallery() {
    const track = document.getElementById("galleryTrack");
    const thumbs = document.getElementById("galleryThumbs");
    if (!track || !thumbs) return;
    const imgs = [...track.querySelectorAll("img")];
    thumbs.innerHTML = imgs.map((img, i) =>
      `<button type="button" class="${i === 0 ? "on" : ""}" aria-label="Image ${i + 1}"><img src="${img.currentSrc || img.getAttribute("src")}" alt=""></button>`
    ).join("");
    const btns = [...thumbs.querySelectorAll("button")];
    btns.forEach((b, i) => b.addEventListener("click", () => track.scrollTo({ left: imgs[i].offsetLeft - track.offsetLeft, behavior: "smooth" })));
    track.addEventListener("scroll", () => {
      const i = Math.round(track.scrollLeft / track.clientWidth);
      btns.forEach((b, j) => b.classList.toggle("on", j === i));
    }, { passive: true });
  }

  /* ---- delivery timeline: ships after N business days, delivered M days later ---- */
  function eta() {
    const box = document.querySelector(".timeline");
    if (!box) return;
    const n = k => parseInt(box.dataset[k], 10) || 0;
    const now = new Date();
    const short = d => d.toLocaleDateString("en-US", { month: "short", day: "numeric" });
    const biz = k => { const d = new Date(now); while (k > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) k--; } return d; };
    const plus = (d, k) => new Date(d.getFullYear(), d.getMonth(), d.getDate() + k);
    const ship1 = biz(n("shipMin")), ship2 = biz(n("shipMax"));
    box.querySelector("[data-eta-order]").textContent = short(now);
    box.querySelector("[data-eta-ship]").textContent = `${short(ship1)} – ${short(ship2)}`;
    box.querySelector("[data-eta-from]").textContent = short(plus(ship1, n("transitMin")));
    box.querySelector("[data-eta-to]").textContent = short(plus(ship2, n("transitMax")));
  }

  /* ---- cart (Shopify AJAX API) ---- */
  let cartState = null;
  async function api(path, body) {
    const res = await fetch(root + path, body
      ? { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body) }
      : { headers: { Accept: "application/json" } });
    const json = await res.json();
    if (!res.ok) throw new Error(json.description || json.message || "Cart error");
    return json;
  }
  const fetchCart = async () => (cartState = await api("cart.js"));

  function renderCart() {
    const box = document.getElementById("cartLines");
    if (!box || !cartState) return;
    const count = cartState.item_count;
    document.querySelectorAll(".cart-count").forEach(b => { b.hidden = !count; b.textContent = count; });
    if (!cartState.items.length) {
      box.innerHTML = '<p class="empty">Your cart is empty.</p>';
    } else {
      const guides = ALL_GUIDES.filter(g => cartState.items.some(it => (tierByVariant(it.variant_id) || { guides: [] }).guides.includes(g)));
      box.innerHTML = cartState.items.map((it, i) => {
        const t = tierByVariant(it.variant_id);
        const title = t ? `${it.product_title} · ${t.name}` : it.title;
        const sub = t ? plural(t.units) : (it.variant_title || "");
        const img = it.image ? it.image + (it.image.includes("?") ? "&" : "?") + "width=160" : DATA.image;
        return `<div class="line"><img src="${img}" alt=""><div><div class="t">${title}</div><div class="s">${sub}</div>` +
          `<div class="qty"><button type="button" data-qty="${i + 1}" data-to="${it.quantity - 1}" aria-label="Remove one">−</button><span>${it.quantity}</span><button type="button" data-qty="${i + 1}" data-to="${it.quantity + 1}" aria-label="Add one">+</button></div></div>` +
          `<div class="r">${money(it.final_line_price)}${t && t.compare ? `<s>${money(t.compare * it.quantity)}</s>` : ""}</div></div>`;
      }).join("") +
        guides.map(g => `<div class="line bonus"><img src="${DATA.guideImages[g] || ""}" alt=""><div><div class="t">${g}</div><div class="s">PDF, sent by email after checkout</div></div><div class="r">FREE</div></div>`).join("");
    }
    const total = document.getElementById("cartTotal");
    if (total) total.textContent = money(cartState.total_price);
    const checkout = document.getElementById("checkoutBtn");
    if (checkout) checkout.setAttribute("aria-disabled", String(!cartState.items.length));
  }

  function openCart() {
    document.getElementById("overlay")?.classList.add("show");
    const d = document.getElementById("drawer");
    if (!d) return;
    d.classList.add("show");
    d.setAttribute("aria-hidden", "false");
  }
  function closeCart() {
    document.getElementById("overlay")?.classList.remove("show");
    const d = document.getElementById("drawer");
    if (!d) return;
    d.classList.remove("show");
    d.setAttribute("aria-hidden", "true");
  }
  function toast(msg) {
    const t = document.getElementById("toast");
    if (!t) return;
    t.textContent = msg;
    t.classList.add("show");
    clearTimeout(toast.timer);
    toast.timer = setTimeout(() => t.classList.remove("show"), 3200);
  }

  async function addToCart(id, btn) {
    const t = tierById(id);
    if (!t) return;
    btn?.classList.add("is-loading");
    try {
      await api("cart/add.js", { items: [{ id: t.variantId, quantity: 1 }] });
      await fetchCart();
      renderCart();
      openCart();
    } catch (err) {
      toast(err.message);
    } finally {
      btn?.classList.remove("is-loading");
    }
  }
  async function changeLine(line, quantity) {
    try {
      cartState = await api("cart/change.js", { line, quantity });
      renderCart();
    } catch (err) {
      toast(err.message);
    }
  }

  document.getElementById("sd-product-form")?.addEventListener("submit", e => {
    e.preventDefault();
    addToCart(selected, e.submitter || e.target.querySelector("[type=submit]"));
  });

  document.addEventListener("click", e => {
    const add = e.target.closest("[data-add-selected]");
    if (add && add.type !== "submit") return addToCart(selected, add);
    const addT = e.target.closest("[data-add-tier]");
    if (addT) { selectTier(addT.dataset.addTier); return addToCart(addT.dataset.addTier, addT); }
    if (e.target.closest("[data-open-cart]")) { fetchCart().then(renderCart); return openCart(); }
    if (e.target.closest("[data-close-cart]")) return closeCart();
    const q = e.target.closest("[data-qty]");
    if (q) return changeLine(+q.dataset.qty, Math.max(0, +q.dataset.to));
    const checkout = e.target.closest("#checkoutBtn");
    if (checkout && checkout.getAttribute("aria-disabled") === "true") return e.preventDefault();
    const s = e.target.closest("[data-slide]");
    if (s) {
      const slides = s.closest("section").querySelector("[data-slides]");
      const first = slides && slides.firstElementChild;
      if (first) slides.scrollBy({ left: +s.dataset.slide * first.offsetWidth * 1.05, behavior: "smooth" });
    }
  });
  document.addEventListener("keydown", e => { if (e.key === "Escape") closeCart(); });

  /* ---- sticky bar: visible once the main add-to-cart button scrolls out of view, hidden near the final CTA ---- */
  const mainAtc = document.querySelector(".info [data-add-selected]");
  const finalCta = document.querySelector(".final");
  const sticky = document.getElementById("stickyAtc");
  if (mainAtc && sticky) {
    let ticking = false;
    const sync = () => {
      ticking = false;
      const passedAtc = mainAtc.getBoundingClientRect().bottom < 0;
      const f = finalCta ? finalCta.getBoundingClientRect() : { top: Infinity, bottom: -Infinity };
      const finalInView = f.top < innerHeight && f.bottom > 0;
      const show = passedAtc && !finalInView;
      sticky.classList.toggle("show", show);
      sticky.setAttribute("aria-hidden", String(!show));
      sticky.querySelector("button").tabIndex = show ? 0 : -1;
    };
    addEventListener("scroll", () => { if (!ticking) { ticking = true; requestAnimationFrame(sync); } }, { passive: true });
    addEventListener("resize", sync);
    sync();
  }

  renderGallery();
  if (selected) selectTier(selected);
  eta();
  fetchCart().then(renderCart).catch(() => {});
})();
